import type { CSSProperties } from 'react';
import type { HeroConfigDto } from '../api/game';

const portraitPosition: Record<string, readonly [number, number]> = {
  'zhou-cang': [0, 0], 'liao-hua': [1, 0], 'guan-ping': [2, 0], 'jian-yong': [3, 0],
  'huang-zhong': [0, 1], 'xu-huang': [1, 1], 'huang-gai': [2, 1], 'cai-wenji': [3, 1],
  'zhao-yun': [0, 2], 'zhang-fei': [1, 2], 'cao-cao': [2, 2], 'sun-shangxiang': [3, 2],
  'lv-bu': [0, 3], 'guan-yu': [1, 3], 'zhuge-liang': [2, 3], 'zhou-yu': [3, 3],
};

export function HeroAvatar({ hero, size = 'medium' }: { hero: Pick<HeroConfigDto, 'heroId' | 'name' | 'rarity'>; size?: 'small' | 'medium' | 'large' }) {
  const [column, row] = portraitPosition[hero.heroId] ?? [0, 0];
  const style = { '--portrait-x': `${column * 100 / 3}%`, '--portrait-y': `${row * 100 / 3}%` } as CSSProperties;
  return <span className={`hero-avatar ${size} rarity-${hero.rarity}`} aria-label={`${hero.name}武将头像`}>
    <span className="hero-initial" aria-hidden="true">{hero.name.slice(0, 1)}</span>
    <span className="hero-portrait" style={style} aria-hidden="true" />
    <i aria-hidden="true" />
  </span>;
}
